<!-- Cart counter icon -->
<div [ngClass]="{ 'bm--bg-popup': showCartPopup }" (click)="closeCartPopup()"></div>

<div class="cart-counter">
  <div (click)="openCartPopup()">
    <bmcore-cart-counter-icon></bmcore-cart-counter-icon>
  </div>

  <!-- Cart popup -->
  @if (showCartPopup) {
    <div class="cart-counter__popup" (click)="$event.stopPropagation()">
      <div class="cart-popup__container bm--scroll-bar theme-cartPopup__bg">
        <div class="bm--dropdown-triangle theme-cartPopup__bg"></div>
        <div class="cart-popup__header-container">
          <p class="cart-popup__cart-title theme-cartPopup__title">{{ lg.cartPage.cart }}</p>
          <div class="btv-icon-close theme-cartPopup__closeIcon" (click)="closeCartPopup()"></div>
        </div>
        @if (!cartGroups.length) {
          <p class="cart-popup__empty-cart">{{ lg.cartPage.emptyCart }}</p>
        }
        <!-- Track list -->
        @for (group of cartGroups; track group) {
          <div class="cart-popup__content-container">
            <div class="cart-popup__tracks-container">
              @for (track of group.beats; track track) {
                <bmcore-track-in-cart-popup
                  [track]="track"
                  (closeCartPopupEvent2)="closeCartPopup()"
                  [appType]="appType"
                >
                </bmcore-track-in-cart-popup>
              }
            </div>
            <bmcore-payment-bottom-block
              class="cart-popup__payment-container"
              [priceWithDiscount]="group.priceWithDiscount"
              [cashbackAmount]="group.cashbackAmount"
              [currencySign]="currencySign"
              [parentComponent]="'Cart popup'"
            >
            </bmcore-payment-bottom-block>
          </div>
        }
        <bmcore-button
          class="cart-popup__payment-button"
          themeBtnClass="theme-btn__cartPopup-btnGoToPayment"
          themeIconClass="theme-icon__cartPopup-btnIconGoToPayment"
          title="{{ lg.button.toPayment }}"
          icon="btv-icon-cart"
          routerPath="{{ checkoutPage }}"
          (clickHandler)="closeCartPopup()"
        >
        </bmcore-button>
      </div>
    </div>
  }
</div>
